// U+200B..U+200D (zero-width space/joiners), U+2060 (word joiner), U+FEFF (BOM).
const ZERO_WIDTH = new RegExp(`[${String.fromCharCode(0x200b)}-${String.fromCharCode(0x200d)}${String.fromCharCode(0x2060, 0xfeff)}]`, 'g');

/**
 * Canonical text for storage and comparison: NFC, no zero-width characters,
 * collapsed whitespace. Thai combining marks are preserved by NFC.
 */
export function cleanText(input: string | null | undefined): string {
  if (input == null) return '';
  return input.normalize('NFC').replace(ZERO_WIDTH, '').replace(/\s+/g, ' ').trim();
}

/**
 * Key for search/indexing only (never for identity or dedup decisions):
 * cleaned, lower-cased latin, punctuation stripped.
 */
export function searchKey(input: string | null | undefined): string {
  return cleanText(input)
    .toLowerCase()
    .replace(/[\p{P}\p{S}]+/gu, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Escape user text for use inside a SQL LIKE pattern (with ESCAPE '\'). */
export function escapeLike(input: string): string {
  return input.replace(/[\\%_]/g, (m) => `\\${m}`);
}

/** Prevent CSV/spreadsheet formula injection on export. */
export function csvSafeCell(value: unknown): string {
  if (value == null) return '';
  let s = String(value);
  if (/^[=+\-@\t\r]/.test(s)) s = `'${s}`;
  if (/[",\n\r]/.test(s)) s = `"${s.replace(/"/g, '""')}"`;
  return s;
}

/** Short one-line preview for inbox rows and admin notifications. */
export function preview(input: string | null | undefined, max = 80): string {
  const s = cleanText(input);
  if (s.length <= max) return s;
  return `${Array.from(s).slice(0, max - 1).join('')}…`;
}
